import React, { useEffect } from "react";
import {
  Button,
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Timeline,
  Drawer,
  Form,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { updateScanLimit } from "../../actions/code";

import { Title, Wrapper } from "./detailStyle";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import {

  CheckSquareFilled,
 
  WarningOutlined,
} from "@ant-design/icons";
import Remarks from "../../component/remark";
import { getCodeDetails, updateCodeActive } from "../../actions/code";

import { renderInput, renderTextField } from "../../component/form/form";
const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};
const CodeCMDetails = ({
  location,
  getCodeDetails,
  updateCodeActive,
  updateScanLimit,
}) => {
  const [visible, setVisible] = useState(false);
  const [locVisible, setLocVisible] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(null);
  const [remarkaccount, setRemarkAccount] = useState(false);
  const id = new URLSearchParams(location.search).get("code");
  useEffect(async () => {
    const res = await getCodeDetails(id);

    setData(res);
    form.setFieldsValue({
      scan_limit: res?.code?.scan_limit,
      location_limit: res?.code?.dif_location_limit,
    });
  }, []);

 
  const Refresh = async () => {
    const res = await getCodeDetails(data?.code?.code_id);
    setData(res);
    form.setFieldsValue({
      scan_limit: res?.code?.scan_limit,
      location_limit: res?.code?.dif_location_limit,
    });
  };
  const handleRefresh = async () => {
    const res = await getCodeDetails(data?.code?.code_id);

    setData(res);
  };
  const handleblocking = (status) => {
    setStatus(status);
    setRemarkAccount(true);
  };
  const onLocFinish = async (values) => {
    const code = await updateScanLimit(values, data?.code?.code_id,'location-scan');

    form.resetFields();
    if (code === 201) {
      setLocVisible(false);
      Refresh();
    }
  };
  const onFinish = async (values) => {
    const code = await updateScanLimit(values, data?.code?.code_id,'total-scan');

    form.resetFields();
    if (code === 201) {
      setVisible(false);
      Refresh();
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  const makeLocalTime = (date) => {
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      date.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };

  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Batch Details</Breadcrumb.Item>
      </Breadcrumb>

      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Code Details"
        subTitle="Code Management"
      ></PageHeader>
      <br />
      <Wrapper>
        {data?.code?.block === false ? (
          <Tag color="#3be910">Active </Tag>
        ) : (
          <Tag color="#cf5220">Blocked</Tag>
        )}

        {data?.code?.block === false ? (
          <Button
            type="ghost"
            icon={<CheckSquareFilled />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#f04545",
              color: "#fff",
            }}
            onClick={() => {
              handleblocking("block");
            }}
          >
            Block code
          </Button>
        ) : (
          <Button
            type="ghost"
            icon={<WarningOutlined />}
            size="small"
            style={{
              float: "right",
              backgroundColor: "#59f045",
              color: "#fff",
            }}
            onClick={() => {
              handleblocking("active");
            }}
          >
            Unblock Code
          </Button>
        )}
      </Wrapper>
      <Wrapper>
        <Title>Code Details </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="CODE ID">
            <strong>{data?.code?.code_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Location Limit">
            <strong>{data?.code?.dif_location_limit}</strong>
            &nbsp;&nbsp;
            <>
              <Button
                type="primary"
                onClick={() => {
                  setLocVisible(true);
                }}
              >
                Update
              </Button>
              <Drawer
                title="Update Location Limit"
                placement="right"
                closable={false}
                visible={locVisible}
                width={500}
                onClose={() => {
                  setLocVisible(false);
                }}
              >
                {data ? (
                  <Form
                    name="basic"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={onLocFinish}
                    onFinishFailed={onFinishFailed}
                    style={{ alignSelf: "center" }}
                    requiredMark={false}
                    form={form}
                  >
                    {renderInput("location_limit", "Set limit", [
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ])}
                    {renderTextField("remark", "Remark", [
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ])}

                    <Form.Item {...tailLayout}>
                      <Button type="primary" htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Form>
                ) : null}
              </Drawer>
            </>
          </Descriptions.Item>
          <Descriptions.Item label="Scaned Limit">
            <strong>{data?.code?.scan_limit}</strong>
            &nbsp;&nbsp;
            <>
              <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                }}
              >
                Update
              </Button>
              <Drawer
                title="Update Scan Unit"
                placement="right"
                closable={false}
                visible={visible}
                width={500}
                onClose={() => {
                  setVisible(false);
                }}
              >
                {data ? (
                  <Form
                    name="basic"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    style={{ alignSelf: "center" }}
                    requiredMark={false}
                    form={form}
                  >
                    {renderInput("scan_limit", "Set limit", [
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ])}
                    {renderTextField("remark", "Remark", [
                      {
                        required: true,
                        message: "This field is required!",
                      },
                    ])}

                    <Form.Item {...tailLayout}>
                      <Button type="primary" htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Form>
                ) : null}
              </Drawer>
            </>
          </Descriptions.Item>
          <Descriptions.Item label="Total Scaned">
            <strong>{data?.code?.scan_count}</strong>
          </Descriptions.Item>
        </Descriptions>
        <br />

        <Title>Last Scaned </Title>
        <br />
        <Descriptions>
        <Descriptions.Item label="Id">
            <strong>{data?.code?.last_scan?.app_user?.user_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Name">
            <strong>{data?.code?.last_scan?.app_user?.name}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Mobile Number">
            <strong>{data?.code?.last_scan?.app_user?.mobile_number}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Coordinates">
            <strong>
              {data?.code?.last_scan?.coordinates[1]},{" "}
              {data?.code?.last_scan?.coordinates[0]}
            </strong>
          </Descriptions.Item>

          <Descriptions.Item label="Ip Address">
            <strong>{data?.code?.last_scan?.ip}</strong>
          </Descriptions.Item>
        </Descriptions>
        <br />
        <Title>Client </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="ID">
            <strong>{data?.code?.client?.user_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Name">
            <strong>{data?.code?.client?.name}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            <strong>{data?.code?.client?.email}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Brand Name">
            <strong>{data?.code?.client?.brand_name}</strong>
          </Descriptions.Item>
        </Descriptions>
        <br />
        <Title>Batch </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="ID">
            <strong>{data?.code?.batch?.batch_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Title">
            <strong>{data?.code?.batch?.title}</strong>
          </Descriptions.Item>

          <Descriptions.Item label="Brand Name">
            <strong>{data?.code?.brand_name}</strong>
          </Descriptions.Item>
        </Descriptions>

        <br />

        <Title>Product </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="ID">
            <strong>{data?.code?.product?.product_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Name">
            <strong>{data?.code?.product?.name}</strong>
          </Descriptions.Item>

          <Descriptions.Item label="Product Name">
            <strong>{data?.code?.product_name}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Product Image">
            <img
              style={{ width: "60px" }}
              src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.code?.product_thumbnail}`}
            />
          </Descriptions.Item>
        </Descriptions>

        <br />
        {data?.code?.logs ? (
          <Timeline mode="left">
            {data.code.logs.map((item, index) => (
              <Timeline.Item
                label={makeLocalTime(item?.created_at)}
                keys={index}
              >
                {item?.message}
              </Timeline.Item>
            ))}
          </Timeline>
        ) : null}

        <br />
        <br />
      </Wrapper>

      <Remarks
        title=" "
        btn="Submit"
        placement="bottom"
        visible={remarkaccount}
        fnc={() => setRemarkAccount(false)}
        id={[data?.code?.code_id, status]}
        delFnc={updateCodeActive}
        refresh={handleRefresh}
      />
    </Content>
  );
};

export default connect(null, {
  getCodeDetails,
  updateCodeActive,
  updateScanLimit,
})(CodeCMDetails);
